import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../../Shared/Typography/Typography";

interface INewlyCalculatedGADDetailsProps extends IProcessComponentProps {
    data: PensionContribution;
}

interface INewlyCalculatedGADDetailsState {}

export class NewlyCalculatedGADDetails extends ProcessComponent<
    INewlyCalculatedGADDetailsProps,
    INewlyCalculatedGADDetailsState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getConfig() {
        const { data } = this.props;
        const gadRates = data?.DrawdownModel?.GadRates;
        const options = [
            {
                title: "GAD Maximum",
                data: MoneyDisplayHelper.FromatMoneyDisplay(gadRates?.GadMaximum),
            },
        ];
        if (gadRates?.NextGadMaximum < gadRates?.GadMaximum) {
            options.push({
                title: "Next year's GAD maximum",
                data: MoneyDisplayHelper.FromatMoneyDisplay(gadRates?.NextGadMaximum),
            });
        }
        return options;
    }

    public render(): JSX.Element {
        return (
            <>
                <h3>Newly calculated GAD details</h3>
                <Typography type="common" wrapCss="text-bold" config={this.getConfig()} />
            </>
        );
    }
}
